
/* loads an image lazily (and displays it once it's been fully loaded)
- selector is expected to be a <div> element. if you add an <img class="notFoundImage"> image, that one will be loaded on error
*/
export function loadImage($div: JQuery<HTMLElement>, url: string) {
    if ($div.length == 0) return;
    if ($div.data('_imgUrl') === url) return; // URL hasn't changed

    initContainer($div);
    if (url == null || url == '') unload($div);

    let $img = $('<img>');
    $img.attr('src', url);
    $img.on('error', (a,b,c) => {
        unload($div);
        console.log('image error: ', a, b, c);
    }).on('load', (a,b,c) => {
        $div.empty().append($img.show());
        console.log('image loaded: ', a, b, c);
    });
    $div.data('_imgUrl', url);
    $div.append($img.hide());
}

// unload the image (i.e. show the placeholder .notFoundImage)
export function unload($div: JQuery<HTMLElement>) {
    let $notFoundImage = $div.data('_notFoundImage');
    $div.empty();
    if ($notFoundImage == undefined) return; // there isn't one
    $div.append($notFoundImage);
}

// initialize the container <div>
function initContainer($div: JQuery<HTMLElement>) {
    if ($div.data("_notFoundImage") !== undefined) {
        return; // already initialized
    }

    let $notFoundImage = $('img.notFoundImage', $div);
    if ($notFoundImage.length == 0) {
        $div.data("_notFoundImage", null);
        return;
    }

    // remove the element from the DOM, but keep it in memory
    $div.data("_notFoundImage", $notFoundImage);
    console.log('image container initialized');
}